export default __webpack_public_path__ + "static/media/biofit-foundation-upholstered.8b8390d4.jpg";